import { gql } from "graphql-request";

import { FRAGMENT_EMPLOYEE_PREFERENCES, FRAGMENT_OWNER } from "./fragments";

export const MUTATION_CREATE_DELIVERY_EVENT = gql`
  mutation createDeliveryEvent($input: CreateDeliverInput!) {
    createDeliveryEvent(input: $input) {
      id
      receiver {
        id
        email
        phone
        availablePreferences {
          ...FragmentEmployeePreferences
        }
      }
      videoRoom {
        id
        roomUrl
      }
    }
  }
  ${FRAGMENT_EMPLOYEE_PREFERENCES}
`;

export const MUTATION_CREATE_GUEST_VISITOR = gql`
  mutation createGuestVisitor($input: CreateGuestVisitor!) {
    createGuestVisitor(input: $input) {
      id
      type
      owner {
        ...FragmentAccessEventOwner
      }
      receiver {
        id
        email
        phone
        fullName
        availablePreferences {
          ...FragmentEmployeePreferences
        }
      }
    }
  }
  ${FRAGMENT_OWNER}
`;

export const MUTATION_ACCESS_SCAN = gql`
  mutation accessScan($input: MemberAccessCheckInInput!) {
    accessScan(input: $input) {
      id
      type
      owner {
        ...FragmentAccessEventOwner
      }
      metadata
      receiver {
        id
        email
        phone
        availablePreferences {
          ...FragmentEmployeePreferences
        }
      }
      videoRoom {
        id
        roomUrl
      }
    }
  }
  ${FRAGMENT_OWNER}
`;

export const MUTATION_CREATE_SCREEN_EVENT = gql`
  mutation createScreenEvent($input: CreateScreenEventInput!) {
    createScreenEvent(input: $input) {
      id
    }
  }
`;

export const MUTATION_CREATE_GUEST = gql`
  mutation createGuest($input: CreateGuest!) {
    createGuest(input: $input) {
      id
      type
      owner {
        ...FragmentAccessEventOwner
      }
      receiver {
        id
        email
        phone
        fullName
        availablePreferences {
          ...FragmentEmployeePreferences
        }
      }
      videoRoom {
        id
        roomUrl
      }
    }
  }
  ${FRAGMENT_OWNER}
`;

export const MUTATION_CHECKOUT_OWNER = gql`
  mutation checkOutOwner($id: ID!) {
    checkOutOwner(id: $id) {
      id
      type
    }
  }
`;

export const MUTATION_CREATE_CUSTOM_DELIVERY_EVENT = gql`
  mutation createCustomDeliveryEvent($input: CreateCustomDeliveryInput!) {
    createCustomDeliveryEvent(input: $input) {
      id
      customReceiver {
        phone
      }
    }
  }
`;

export const MUTATION_CREATE_VIDEO_ROOM = gql`
  mutation accessEventCreateVideoRoom($id: ID!) {
    accessEventCreateVideoRoom(id: $id) {
      id
      roomUrl
    }
  }
`;

export const MUTATION_DELETE_VIDEO_ROOM = gql`
  mutation accessEventDeleteVideoRoom($id: ID!) {
    accessEventDeleteVideoRoom(id: $id)
  }
`;

export const MUTATION_ACCESS_EVENT_GET_CALLER_ACS_TOKEN_AND_TARGET_TEAMS_USER_ID = gql`
  mutation accessEventGetCallerAcsTokenAndTargetTeamsUserId($id: ID!) {
    accessEventGetCallerAcsTokenAndTargetTeamsUserId(id: $id) {
      callerAcsToken
      targetTeamsUserId
    }
  }
`;

export const MUTATION_SEND_DOOR_OPENED_NOTIFICATION = gql`
  mutation accessEventSendDoorOpenedNotification($id: ID!) {
    accessEventSendDoorOpenedNotification(id: $id) {
      id
    }
  }
`;

export const MUTATION_GET_CALLER_ACS_TOKEN_AND_TARGET_TEAMS_USER_IDS = gql`
  mutation getCallerAcsTokenAndTargetTeamsUserIds(
    $input: CallerAcsTokenAndTargetTeamsUsersInput!
  ) {
    getCallerAcsTokenAndTargetTeamsUserIds(input: $input) {
      callerAcsToken
      targetTeamsUsers {
        email
        isGroup
        teamsUsers {
          email
          teamsUserId
        }
      }
    }
  }
`;

export const MUTATION_SWITCH_SHELLY_CONTROLLER = gql`
  mutation switchShellyController($input: SwitchShellyControllerInput!) {
    switchShellyController(input: $input)
  }
`;

export const MUTATION_SWITCH_TUYA_CONTROLLER = gql`
  mutation switchTuyaController($input: SwitchTuyaControllerInput!) {
    switchTuyaController(input: $input)
  }
`;
